import RoutingService from "services/RoutingService";

const Logo = () => {
  return (
      <img className="logo" src={`/projects/${RoutingService.getProjectFromUrl().toLowerCase()}/logo.svg`} alt="AI Agent" width="100" />
  );
};

export default Logo;
